import { create } from 'zustand';
import type { AppStore } from '@/types/store';
import { createIngredientSlice } from './slices/ingredientSlice';
import { createDetectionSlice } from './slices/detectionSlice';
import { createRegulatorySlice } from './slices/regulatorySlice';
import { createProfileSlice } from './slices/profileSlice';
import { createUISlice } from './slices/uiSlice';
import { createAuditSlice } from './slices/auditSlice';

export const useAppStore = create<AppStore>()((set, get) => ({
  ...createIngredientSlice(set),
  ...createDetectionSlice(set, get),
  ...createRegulatorySlice(set, get),
  ...createProfileSlice(set),
  ...createUISlice(set),
  ...createAuditSlice(set),
}));

export * from './selectors';
